module.exports = __webpack_public_path__ + "img/The Role of a Pharmacist in Public Health.477f31e8.jpg";